import { FC } from "react";

interface Props {
  className?: string;
  stroke?: string;
  strokeWidth?: string;
}

const ChevronLeft: FC<Props> = ({
  stroke = "#000",
  strokeWidth = "1",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="16"
      viewBox="0 0 9 16"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      >
        <g stroke={stroke} transform="translate(-16 -13)">
          <g transform="matrix(-1 0 0 1 43 0)">
            <path
              d="M14 0L7 7.73175271 0 0"
              transform="rotate(-90 23.343 4.476)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export { ChevronLeft };
